import React, { useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ManagementReportForm from 'app/components/ManagementReportForm';
import { clearManagementReportFilter } from 'app/actions/ManagementReportActions';


import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './ManagementReportScreenStyles';
import { useDispatch } from 'react-redux';


export default function ClientReportScreen(props) {
    const classes = useStyles();
    const dispatch= useDispatch();

    useEffect(() => {
        return () => {
            dispatch(clearManagementReportFilter());
        }
    }, []);
   
    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isManag={true} header='Reporte Gerencial' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Gestión
                            </Link>
                        <TextEvents
                            text="Reporte Gerencial"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Grid container spacing={0}>
                    <Grid item xs={12} md={12}>
                        <Paper className={classes.rootPaper}>
                            <ManagementReportForm styles={styles} classes={classes}/>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}